import React, { useEffect, useState } from 'react';
import Preview from './preview';
import smileGirl from "../../../assets/claraViewMedia/smile-girl.jpg"
import { useNavigate } from 'react-router-dom';
import { getLocalStorageJSON } from '../../../Utils/safeLocalStorage';
import { logEvent } from '../../../Utils/logEvent';

const DemoScreen = () => {
    const navigate = useNavigate();
    const app = localStorage.getItem("company");
    const uid = getLocalStorageJSON("usertpi").usertpi;
    const [selectedImage, setSelectedImage] = useState(null);
    const [showPreview, setShowPreview] = useState(false);

    useEffect(() => {
        logEvent({ app, uid, event: "visited on demo screen" });
        const isScanComplete = localStorage.getItem("isScanCompleted");
        if (isScanComplete) {
            const client = app.split("-")[1];
            navigate(`/${client}`);
        }
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (validTypes.includes(file.type)) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    setSelectedImage(e.target.result);
                    setShowPreview(true);
                };
                reader.readAsDataURL(file);
                logEvent({ app, uid, event: "loaded image file" });
            } else {
                alert('Please select a valid image file (JPEG, JPG, or PNG)');
                logEvent({ app, uid, event: "invalid image file selected" });
            }
        } else {
            alert('Please select an image file');
            logEvent({ app, uid, event: "no image file selected" });
        }
    };

    const retake = () => {
        logEvent({ app, uid, event: "re-taking the image" });
        setShowPreview(false);
        setSelectedImage(null);
    };

    const revert = () => {
        setShowPreview(false);
        setSelectedImage(null);
    };

    const cameraCapture = () => {
        logEvent({ app, uid, event: "camera capture opted" });
        navigate(`/claraview/scan`);
    };

    const tips = [
        "Use good, even lighting with no harsh shadows.",
        "Face the camera directly with a wide, natural smile.",
        "Have someone take the photo rather than a selfie.",
        "For possible better results, upload a high-quality photo you already have.",
    ];

    return (
        <div className={`h-full flex flex-col ${showPreview && selectedImage ? 'white' : 'bg-gradient-to-br'}  from-[#161612] to-[#5B6058] font-sans overflow-hidden`}>
            {showPreview && selectedImage ? (
                <Preview
                    continue={() => { }}
                    image={selectedImage}
                    setImageSide={() => { }}
                    setCamera={retake}
                    onClose={() => setShowPreview(false)}
                    setDemo={revert}
                    isFileUpload={true}
                />
            ) : (
                <>
                    {/* ── Face image: takes upper ~50% ── */}
                    <div className="relative w-full p-3" style={{ height: '52%', minHeight: 0 }}>
                        <img
                            src={smileGirl}
                            alt="Face Position Demo"
                            className="w-full h-full object-cover rounded-md"
                        />



                    </div>

                    {/* ── Lower dark panel ── */}
                    <div className="flex flex-col flex-1 px-6 pt-4 pb-4 gap-5">

                        {/* Headline */}
                        <p className="text-white text-center text-[25px] font-normal leading-7">
                            The clearer your photo,<br />
                            the better the Smile Simulation.
                        </p>

                        {/* Tips card */}
                        <div className="rounded-xl border border-white/10 bg-white/5 px-4 py-4">
                            <p className="text-[10px] font-semibold font-dashboard text-white/40 uppercase mb-3">
                                For the best simulation results
                            </p>
                            <ul className="space-y-2">
                                {tips.map((tip, i) => (
                                    <li key={i} className="flex items-start gap-2 text-white/70 text-[13px] leading-snug">
                                        <span className="mt-[5px] w-[5px] h-[5px] rounded-full bg-white/50 flex-shrink-0" />
                                        {tip}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-col gap-3 mt-auto">
                            {/* Upload — primary */}
                            <button
                                className="w-full flex items-center justify-between bg-white text-[#2C2C28] text-[15px] font-semibold uppercase px-6 py-4 rounded-full"
                                onClick={() => {
                                    document.getElementById('imageUploadClaraView').click();
                                    logEvent({ app, uid, event: "uploading image file" });
                                }}
                            >
                                <span>Upload Photo</span>
                                <span className="w-8 h-8 rounded-full bg-[#58665A] flex items-center justify-center flex-shrink-0">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </button>

                            <input
                                id="imageUploadClaraView"
                                type="file"
                                onChange={handleFileChange}
                                accept="image/jpeg, image/jpg, image/png"
                                style={{ display: 'none' }}
                            />

                            {/* Capture — ghost */}
                            <button
                                className="w-full text-center border border-[#FFFFFF29] text-white/70 text-[13px] font-medium tracking-widest uppercase py-3 rounded-full"
                                onClick={cameraCapture}
                            >
                                Capture Photo
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default DemoScreen;